module.exports = "https://static.wanderu.com/ui-react/_next/static/media/apple-store.6902bc18.png";